(function ($, Cobalt, undefined) {
    Cobalt.Forum = {
        dependentScripts: function () {
            return [{ dependency: Cobalt.User, name: "Cobalt.User" }, { dependency: Cobalt.Markup, name: "Cobalt.Markup" }];
        },
        initialize: function () {
            Cobalt.Forum.bindSearchForm();
            Cobalt.Forum.bindForumSearchBox();
            Cobalt.Forum.markForumAsFiltered();
            Cobalt.Forum.bindBulkThreadMergeForm();
            Cobalt.Forum.enableMobileNavigation();

            Cobalt.runOnHtmlInsert(Cobalt.Forum.addReadStatuses);
            Cobalt.runOnHtmlInsert(Cobalt.Forum.handleForumMarkAllRead);
            Cobalt.runOnHtmlInsert(Cobalt.Forum.createUserMenu);
            Cobalt.runOnHtmlInsert(Cobalt.Forum.deleteThreadMenu);
            Cobalt.runOnHtmlInsert(Cobalt.Forum.modalCancelButton);
            Cobalt.runOnHtmlInsert(Cobalt.Forum.handleWarnForm);
            Cobalt.Forum.bindResponsiveHeaders();
            Cobalt.runOnHtmlInsert(Cobalt.Forum.bindTreeMultipleSelectField);
            Cobalt.Forum.bindForumSearch();

            $().ready(function () {

                $('a.j-mark-forum-read').click(function (e) {
                    e.preventDefault();
                    var forumRow = $(this).parents("tr");
                    var forumID = forumRow.attr("data-id");
                    var latestCommentDate = forumRow.attr("data-latest-comment-date");
                    Cobalt.Forum.markForumRead(forumID, latestCommentDate);
                    Cobalt.Forum.setForumStatus(forumRow);
                    Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                        $.post(Cobalt.Routes.Instance.ForumSetForumSeen(forumID),
                            { 'request-verification-token': token },
                            function () {

                            });
                    });
                });

                $('#begin-date').datepicker();
                $('#end-date').datepicker();

                $('.thread-action-rename').click(function (e) {
                    e.preventDefault();
                    var threadID = parseInt($(this).attr("data-id"));
                    if (threadID) {
                        var wholeTitleElement = $(this).parents('td.col-thread').find('span.j-thread-title');   //whole thread title dom so that we can click cancel link and replaceWith

                        var titleElem = $(".thread-title[data-id=" + threadID + "]");
                        var link = titleElem.find("a.title");
                        var renameUrl = Cobalt.Forum.getThreadActionUrl(threadID, "rename"); //link.attr("href") + "/rename";
                        var title = link.html();

                        // Build up the form
                        var form = $("<form method=\"post\">").attr("action", renameUrl);
                        var renameTextBox = $("<input type=\"text\" name=\"title\">").attr("value", title).attr("data-id", threadID);
                        var updateButton = $("<input type=\"submit\" name=\"update\">").attr("value", L.Global.Buttons.Update());
                        var cancelLink = $('<a id="cancel-thread-title-edit">').attr("href", document.location).text(L.Global.Buttons.Cancel());
                        $(form).append($(renameTextBox)).append($(updateButton)).append($(cancelLink));

                        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                            $(form).append($("<input type=\"hidden\" name=\"request-verification-token\">").attr("value", token));
                        });
                        var titleElemClone = titleElem.clone();
                        titleElem.replaceWith($(form));
                        Cobalt.triggerHtmlInsert(titleElem.parent());

                        form.ajaxForm({
                            beforeSubmit: function () {
                                form.mask();
                            },
                            success: function (data) {
                                titleElemClone.find("a.title").text(data);
                                form.unmask();
                                form.replaceWith(titleElemClone);
                            },
                            error: function () {
                                form.unmask();
                            }
                        });

                        $(":text[data-id=" + threadID + "]").click(function () { return false; });

                        // logic for cancel link
                        $('a#cancel-thread-title-edit').click(function (e) {
                            e.preventDefault();
                            $(this).parent().replaceWith(wholeTitleElement);
                        });
                    }
                });

                $('.thread-action-lock').on("click", lockThread);

                function lockThread(e) {
                    e.preventDefault();
                    var that = $(this);
                    var threadID = parseInt($(this).attr("data-id"));
                    if (threadID) {
                        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                            $.post(Cobalt.Forum.getThreadActionUrl(threadID, "lock"),
                                {'request-verification-token': token},
                                function (data) {
                                that.closest("tr.j-forum-thread-row").removeClass("forum-thread-row-normal").removeClass("forum-thread-row-deleted").addClass("forum-thread-row-locked");
                                var button = that.closest(".thread-action-lock");
                                button.removeClass("thread-action-lock").addClass("thread-action-unlock").attr("title", "Unlock");
                                button.off("click");
                                button.on("click", unlockThread);
                                Cobalt.triggerHtmlInsert(button.parent());
                            });
                        });
                    }
                }

                $('.thread-action-unlock').on("click", unlockThread);

                function unlockThread(e) {
                    e.preventDefault();
                    var that = $(this);
                    var threadID = parseInt($(this).attr("data-id"));
                    if (threadID) {
                        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                            $.post(Cobalt.Forum.getThreadActionUrl(threadID, "unlock"),
                                { 'request-verification-token': token },
                                function (data) {
                                that.closest("tr.j-forum-thread-row").removeClass("forum-thread-row-locked").addClass("forum-thread-row-normal");
                                var button = that.closest(".thread-action-unlock");
                                button.removeClass("thread-action-unlock").addClass("thread-action-lock").attr("title", "Lock");
                                button.off("click");
                                button.on("click", lockThread);
                                Cobalt.triggerHtmlInsert(button.parent());
                            });
                        });
                    }
                }

                $('.thread-action-pin').on("click", pinThread);

                function pinThread(e) {
                    e.preventDefault();
                    var that = $(this);
                    var threadID = parseInt($(this).attr("data-id"));
                    if (threadID) {
                        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                            $.post(Cobalt.Forum.getThreadActionUrl(threadID, "pin"),
                                { 'request-verification-token': token },
                                function (data) {
                                that.closest("tr.j-forum-thread-row").removeClass("forum-thread-row-typical").addClass("forum-thread-row-pinned");
                                var button = that.closest(".thread-action-pin");
                                button.removeClass("thread-action-pin").addClass("thread-action-unpin").attr("title", "Unpin");
                                button.off("click");
                                button.on("click", unpinThread);
                                Cobalt.triggerHtmlInsert(button.parent());
                            });
                        });
                    }
                }

                $('.thread-action-unpin').on("click", unpinThread);

                function unpinThread(e) {
                    e.preventDefault();
                    var that = $(this);
                    var threadID = parseInt($(this).attr("data-id"));
                    if (threadID) {
                        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                            $.post(Cobalt.Forum.getThreadActionUrl(threadID, "unpin"),
                                { 'request-verification-token': token },
                                function (data) {
                                    that.closest("tr.j-forum-thread-row").removeClass("forum-thread-row-pinned").addClass("forum-thread-row-typical");
                                    var button = that.closest(".thread-action-unpin");
                                    button.removeClass("thread-action-unpin").addClass("thread-action-pin").attr("title", "Pin");
                                    button.off("click");
                                    button.on("click", pinThread);
                                    Cobalt.triggerHtmlInsert(button.parent());
                                });
                        });
                    }
                }

                $('.thread-action-add').click(function (e) {
                    e.preventDefault();
                    var that = $(this);
                    var threadID = parseInt($(this).attr("data-id"));
                    if (threadID) {
                        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                            $.post(Cobalt.Forum.getThreadActionUrl(threadID, "add"),
                                { 'request-verification-token': token },
                                function (result) {
                                window.location.reload();
                            }, "json");
                        });
                    }
                });

                // prevent dropdown click event, these are hoverable
                $('li.user-action-tools > a').on('click', function (e) {
                    e.preventDefault();
                });

                //prevent click event on disabled user actions
                $('a.comment-right-side-user-action.disabled').on("click", function (e) {
                    e.preventDefault();
                    return false;
                });

            });

            var createRedirectCheckbox = $("#field-create-redirect");
            var isPermanentField = $("#field-is-permanent");
            var redirectFields = $(".j-redirect-fields");

            if (createRedirectCheckbox.is(":checked")) {
                redirectFields.removeClass("hide").show();
            }

            if (isPermanentField.is(":checked")) {
                redirectFields.find("#field-redirect-time input").attr("disabled", "disabled");
            }

            createRedirectCheckbox.change(function () {
                if ($(this).is(":checked")) {
                    redirectFields.removeClass("hide").show();
                } else {
                    redirectFields.hide();
                }
            });

            isPermanentField.change(function () {
                var redirectTimespanFields = $("#field-redirect-time input");
                if ($(this).is(":checked")) {
                    redirectTimespanFields.attr("disabled", "disabled");
                } else {
                    redirectTimespanFields.removeAttr("disabled");
                }
            });
        },
        bindForumSearchBox: function () {

            $('#field-search-specific-forums').live("input", function () {
                var $forumField = $("#field-forum");
                if ($forumField.length > 0) {
                    var searchVal = $(this).val().toLowerCase();
                    $('div.forum-selection div').children('.tree-item').each(function () {
                        var comparison = $(this).text();
                        $(this).show();
                        if (comparison.toLowerCase().indexOf(searchVal) === -1) {
                            $(this).hide();
                        }
                    });
                }
            });

            var textInput = $('#field-search-specific-forums');
            var searchElem;
            if (textInput.length > 0) {
                searchElem = textInput.attr("data-search-elem");
            }

            var forumField = $("#field-forum");
            if (forumField.length > 0) {
                forumField.find(".inherit-parent input").bind("hide-hidden-inputs", function () {
                    //currently isolated to advanced forum search
                    if ($(this).find(searchElem || "li").is(":hidden")) {
                        $(this).attr("checked", false);
                    }
                });
            }

        },
        getThreadActionUrl: function (threadID, actionName) {
            var titleElem = $(".thread-title[data-id=" + threadID + "]");
            var link = $(titleElem.selector.toString());
            if (link.attr("data-thread-link")) {
                return link.attr("data-thread-link") + "/" + actionName;
            }
            else {
                return document.location;
            }
        },
        markForumRead: function (forumID, latestCommentDate) {
            forumID = parseInt(forumID);
            if ((forumID != undefined) && (latestCommentDate != undefined)) {
                var forumSeen = Cobalt.Forum.ForumSeen;
                if (!(forumSeen instanceof Object)) {
                    forumSeen = {};
                }

                forumSeen[forumID] = latestCommentDate;

                Cobalt.Forum.ForumSeen = forumSeen;
            }
        },
        addReadStatuses: function () {

            $(".j-forum-thread-row").each(function () {
                var row = $(this);
                var threadID = parseInt(row.attr("data-id"));
                var forumID = parseInt(row.attr("data-forum-id"));
                var latestCommentDate = parseInt(row.attr("data-latest-comment-date"));
                var latestCommentUser = parseInt(row.data("latest-comment-author"));

                if (!threadID) {
                    return;
                }
                var latestPostIndex = parseInt(row.attr("data-latest-post-index"));
                if (!latestPostIndex) {
                    return;
                }

                if (row.hasClass("forum-thread-row-redirect")) {
                    return;
                }

                var forumThreadSeen = Cobalt.Forum.ForumThreadSeen;
                if (!(forumThreadSeen instanceof Object)) {
                    forumThreadSeen = {};
                }

                var forumThreadCommented = Cobalt.Forum.ForumThreadCommented;
                if (!(forumThreadCommented instanceof Object)) {
                    forumThreadCommented = {};
                }

                var hasCommented = forumThreadCommented[threadID] || 0;

                var lastSeenPostIndex = forumThreadSeen[threadID] || 0;

                var hasSeenForum = ((Cobalt.Forum.ForumSeen != undefined)
                    && (Cobalt.Forum.ForumSeen[forumID] != undefined)
                    && (latestCommentDate <= Cobalt.Forum.ForumSeen[forumID]));

                // user has seen it already if the last comment was this user
                if ((!isNaN(latestCommentUser) && !isNaN(Cobalt.User.userID)) // neither value is NaN
                    && latestCommentUser === parseInt(Cobalt.User.userID)) { // the values are equal
                    hasSeenForum = true;
                }

                var hasNewerPosts = (latestPostIndex > lastSeenPostIndex) && !hasSeenForum;
                if (hasNewerPosts) {
                    row.addClass("forum-thread-row-unread");
                    row.removeClass("forum-thread-row-read");

                    var statusCol = row.find(".j-thread-status");

                    if (lastSeenPostIndex > 0) {
                        var title = row.find("a.status-icon");
                        if (title.attr("href").indexOf("comment=") === -1) {
                            var firstUnreadUrl = "{0}?comment={1}".format(title.attr("href"), ++lastSeenPostIndex);
                            var link = row.find("#go-next");
                            link.attr('href', firstUnreadUrl);
                            link.addClass("go-next").removeClass("hide");

                            // Status Column Tooltip and Click Handler                        
                            statusCol.find("a").attr("href", firstUnreadUrl);
                            row.addClass("forum-thread-has-unread");
                        }
                    }
                } else {
                    //reset                    
                    if (!row.hasClass("forum-thread-row-read")) {
                        row.addClass("forum-thread-row-read");
                    }
                    row.removeClass("forum-thread-row-unread");
                    row.removeClass("forum-thread-has-unread");

                    var title = row.find("#go-next");
                    if (!title.hasClass("hide")) {
                        title.removeClass("go-next").addClass("hide");
                    }
                }


                if (hasCommented > 0) {
                    var statusCol = row.find(".j-thread-status");
                    statusCol.addClass("forum-thread-commented");
                    statusCol.prop('title', 'You have commented on this thread');
                }


            });

            $(".forum-row, .top-level-forum.can-have-threads").each(function () {
                Cobalt.Forum.setForumStatus($(this));
            });

        },
        createUserMenu: function () {
            $(".forum-post-author").each(function () {
                var usernameLink = $(this).find(".username");
                var usernameMenu = $(this).find(".user-actions-forum-post-author-menu");
                usernameMenu.hide();
                if ($(usernameLink).find("a").attr("href") != "") {
                    usernameLink.hover(
                    function () {
                        usernameMenu.stop(true, true).slideDown(100);
                    },
                    function () {
                        usernameMenu.stop(true, true).slideUp(100);
                    });
                }
            });
        },
        setForumStatus: function (row) {

            var forumID = parseInt(row.attr("data-id"));
            var latestCommentDate = parseInt(row.attr("data-latest-comment-date"));
            var latestPostIndex = parseInt(row.attr("data-latest-post-index"));
            var latestThreadID = parseInt(row.attr("data-latest-thread-id"));
            var latestCommentUser = parseInt(row.data("latest-comment-author"));

            var forumThreadSeen = Cobalt.Forum.ForumThreadSeen;
            if (!(forumThreadSeen instanceof Object)) {
                forumThreadSeen = {};
            }

            var hasSeenForum = false;
            if (latestCommentDate == 0) {
                hasSeenForum = true;
            }
            else if (Cobalt.Forum.ForumSeen != undefined && Cobalt.Forum.ForumSeen[forumID] != undefined && latestCommentDate <= Cobalt.Forum.ForumSeen[forumID]) {
                hasSeenForum = true;
            }

            // user has seen it already if the last comment was this user
            if ((!isNaN(latestCommentUser) && !isNaN(Cobalt.User.userID)) // neither value is NaN
                && latestCommentUser === parseInt(Cobalt.User.userID)) { // the values are equal
                hasSeenForum = true;
            }


            if (hasSeenForum) {
                row.removeClass("forum-row-not-seen-latest-thread");
                row.addClass("forum-row-seen-latest-thread");
            }
            else {
                row.find(".col-status>a").attr("title", Cobalt.Localization.Main.Global.Forums.MarkForumRead());
                row.removeClass("forum-row-seen-latest-thread");
                row.addClass("forum-row-not-seen-latest-thread");

                //var link = row.find(".j-forum-latest-post > a");
                //if (link.length > 0) {
                //    var currentHref = link.attr("href");
                //    var latestThreadID = parseInt(row.attr("data-latest-thread-id"));
                //    var commentDisplayIndex;                    
                //    if (forumThreadSeen[latestThreadID] !== undefined) {
                //        commentDisplayIndex = forumThreadSeen[latestThreadID] + 1;
                //    } else {
                //        commentDisplayIndex = 1;
                //    }
                //    if (currentHref.indexOf("comment=") === -1)
                //    {
                //        link.attr("href", currentHref + "?comment=" + commentDisplayIndex);
                //    }
                //}
            }
        },
        handleForumMarkAllRead: function ($parent) {

            $parent.find('.j-forum-mark-all-as-read').click(function (e) {
                e.preventDefault();
                Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                    $.post(Cobalt.Routes.Instance.ForumSetAllForumSeen(),
                        { 'request-verification-token': token },
                        function (data) {
                        if (data.Success) {
                            Cobalt.Forum.ForumSeen = $.parseJSON(data.ForumSeen);

                            $(".forum-row, .top-level-forum.can-have-threads").each(function () {
                                Cobalt.Forum.setForumStatus($(this));
                            });
                        }
                    });
                });
                var dropdownMenu = $(this).parents(".u-dropDownMenu");
                dropdownMenu.hide();
                setTimeout(function () { dropdownMenu.show(); }, 100);
            });

            $parent.find('.j-forum-thread-mark-all-as-read').click(function (e) {
                e.preventDefault();
                Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                    $.post(Cobalt.Routes.Instance.ForumSetAllForumThreadSeen($(this).attr("data-forum-id")),
                        { 'request-verification-token': token },
                        function (data) {
                        if (data.Success) {
                            Cobalt.Forum.ForumSeen = $.parseJSON(data.ForumSeen);

                            Cobalt.Forum.addReadStatuses();
                        }
                    });
                });
            });

        },
        bindSearchForm: function () {

            $("div.j-advanced-forum-search").find(".j-search-scope input").on("change", function (e) {
                var input = $(this);
                if (input.val() == "t") {
                    $("#field-forum").show();
                    $("#field-search-specific-forums").show();
                }
                else {
                    $("#field-forum").hide();
                    $("#field-search-specific-forums").hide();
                }
            });

            $("div.j-advanced-forum-search").find(".j-search-scope input:checked:visible").trigger("change");

            var forumLinkField = $("#form-field-forum-link-field");
            if (forumLinkField.length > 0) {
                var forumSelectionField = $("#field-forum");
                if (forumSelectionField.length > 0) {
                    var originalForumFieldValues = new Array();
                    forumSelectionField.find("input:checked").each(function () {
                        originalForumFieldValues.push($(this).val());
                    });

                    var selectAdditionalForums = "Select Additional Forums";
                    var dontSelectAdditionalForums = "Don't Select Additional Forums";
                    var anchor = $("<a>")
                                    .attr("href", "#")
                                    .addClass("j-forum-search-select")
                                    .addClass("expand")
                                    .addClass("tip")
                                    .text(selectAdditionalForums)
                                    .attr("title", selectAdditionalForums)
                                    .on("click", function (e) {
                                        e.preventDefault();
                                        if ($(this).hasClass("expand")) {
                                            $(this).text(dontSelectAdditionalForums).removeClass("expand").addClass("collapse");
                                        } else {
                                            $(this).text(selectAdditionalForums).removeClass("collapse").addClass("expand");

                                            // Reset the tree to its original state.
                                            forumSelectionField.find("input[type='checkbox']").each(function () {
                                                $(this).removeAttr("checked");
                                            });
                                            $(originalForumFieldValues).each(function (i, val) {
                                                forumSelectionField.find("input[value='" + val + "']").attr("checked", "checked");
                                            });
                                        }
                                        forumSelectionField.removeClass("hide").toggle();
                                    });
                    Cobalt.triggerHtmlInsert(anchor.parent());
                    forumLinkField.append(anchor);

                }
            }
        }, deleteThreadMenu: function () {
            var statusNote = $('#form-field-field-message');
            statusNote.hide();
            var showStatusNote = false;
            $('#field-show-status-note').click(function () {
                if (showStatusNote) {
                    statusNote.hide();
                } else {
                    statusNote.show();
                }
                showStatusNote = !showStatusNote;
            });
        }, modalCancelButton: function () {
            $("body").on("click", "a.j-cancel-button", function (e) {
                $(this).parents("div.ui-dialog-content").dialog("close");
            });
        }, handleWarnForm: function () {
            var $form = $(".ajax-jump");
            if ($form.length > 0) {
                $form.ajaxForm({
                    beforeSubmit: function () {
                        $form.find(':submit').attr('disabled', 'disabled');
                    },
                    success: function (result) {
                        if (result.Status === undefined || (result.Status !== undefined && result.Status != "invalid")) {
                            $(".ui-dialog-titlebar-close").click();
                            document.location = result.RedirectUrl;
                        } else {
                            $form.find(":submit").removeAttr("disabled");
                            Cobalt.Forms.displayErrors($form, result.Errors);
                        }
                    }
                });
            }
        }, markForumAsFiltered: function () {
            $('th.b-table-heading').each(function () {
                if ($(this).find('a').hasClass('selected')) {
                    $(this).parents('table').find('tbody').addClass('filtered');
                }
            });
        }, bindBulkThreadMergeForm: function () {
            var timeSpanField = $("div#form-field-thread-redirect-duration");
            var redirectCheckbox = $("div#form-field-thread-no-redirect");

            timeSpanField.hide();   //hide the timespan initially

            redirectCheckbox.click(function (e) {
                if (timeSpanField.is(":visible") && !$(this).find("input").is(":checked")) {
                    timeSpanField.hide();
                } else {
                    timeSpanField.show();
                }
            });
        }, enableMobileNavigation: function () {

            var win = $(window);
            //only activate full row navigation is window width is below or equal to 640  
            
                $("tr.j-forum-thread-row,li.j-forum-thread-row").each(function () {
                    var $row = $(this);
                    $row.on("click", function () {
                        if (win.width() <= 640 && $('body').hasClass('responsive-enabled')) {
                            var target = $(event.target);
                            if (!target.hasClass("go-latest")) {//if the target is the go to latest navigate there
                                var url = $row.find(".j-thread-title").attr("data-thread-link");
                                event.preventDefault();
                                window.location = url;
                            }
                            else if ($row.hasClass("forum-thread-has-unread")) {
                                var url = $row.find("td.j-thread-status > a.status-icon").attr("href");
                                event.preventDefault();
                                window.location = url;
                            }
                        }
                    });
                });

                $("tr.forum-row").each(function () {
                    var $row = $(this);
                    $row.on("click", function () {
                        if (win.width() <= 640 && $('body').hasClass('responsive-enabled')) {
                            var target = $(event.target);
                            if (!target.hasClass("go-latest")) { //if the target is the go to latest navigate there
                                var url = $row.find("td.col-forum > .title > a").attr("href");
                                event.preventDefault();
                                window.location = url;
                            }
                        }
                    });
                });
            
        }, relabelResponsiveLinks: function () {
            $('ul.user-actions-forum-post-author-menu').each(function () {
                var responsiveCount = 0;
                $(this).find('li.user-action-link-responsive').each(function () {
                    var label = "";
                    if (!Cobalt.detectIsOnMobile()) {
                        label = $(this).find('a').attr('data-non-responsive-label');
                    } else {
                        label = $(this).find('a').attr('data-responsive-label');
                        responsiveCount++;
                    }
                    $(this).find('span.label').text(label);
                });

                $(this).find('li.user-action-link-responsive').each(function () {
                    $(this).addClass('link-responsive-nav-count-' + responsiveCount);
                });
            });

            $('nav.p-comment-actionsUser').each(function () {
                var responsiveCount = $(this).find('a.comment-right-side-user-action').length;
                $(this).find('a.comment-right-side-user-action').each(function () {
                    $(this).parent().addClass("responsive-bottom-nav-" + responsiveCount);
                });               
            });

            // Below would toggle user actions in forum comments

        }, bindResponsiveHeaders: function () {
            $('div.mobile-profile-target').on('click', function () {
                if ($('body').width() <= 640 || Cobalt.detectIsOnMobile()) {
                    // navigate to the author's profile
                    location.href = $(this).parent().find('div.p-comment-micro-author > a').prop("href");
                }
            });

            // This prevents modal links from opening when within clicked the forum thread listing
            $('td.col-count .modal-link').click(function (e) {
                if ($('body').width() <= 640 || Cobalt.detectIsOnMobile()) {
                    e.preventBubble();
                }
            });
        },
        // this makes it so TreeViewModelChoiceField multiple select fields look correct
        bindTreeMultipleSelectField: function () {
            $('select.tree-item > option').each(function () {
                var padding = "";
                for (var i = 1; i < 10; i++) {
                    padding += "- ";
                    if ($(this).hasClass('tree-field-level-' + i)) {
                        $(this).text(padding + $(this).text());
                    }
                }
            });
            $('select.tree-item').change(function () {
                $(this).parent().submit();
            });
        },
        bindForumSearch: function () {
            $('input.b-search-submit').click(function (e) {
                if ($(this).siblings('input.b-search-input').val().length < 3) {
                    e.preventDefault();
                    $(this).siblings('span.field-errors').remove();
                    $(this).after('<span class="field-errors">Search must have 3 or more characters.</span>');
                    return false;
                }
                return true;
            });

            $('input.b-search-input').change(function () {
                $(this).siblings('.field-errors').remove();
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Forum.js